import { useCallback } from 'react';
import { Avatar } from 'avatar-components/Avatar';
import { getAvatarUrl } from '../../avatar/avatarQueries';
import { getProfilePagePath } from '../../../utils/RoutingUtils';
import PortalIdParser from 'PortalIdParser';
import { jsx as _jsx } from "react/jsx-runtime";
const UsersAvatarList = ({
  users,
  max = 3,
  hasMoreHref
}) => {
  const handleOnClick = useCallback((e, url) => {
    e.preventDefault();
    window.open(url, '_blank');
  }, []);
  return /*#__PURE__*/_jsx(Avatar, {
    borderWidth: "0",
    hasMoreHref: hasMoreHref,
    lookup: users.map(({
      displayName,
      avatarHash,
      userId
    }) => {
      const url = userId ? getProfilePagePath(userId, PortalIdParser.get()) : undefined;
      return {
        displayName,
        onClick: e => url && handleOnClick(e, url),
        src: avatarHash ? getAvatarUrl(avatarHash) : undefined,
        type: 'contact',
        href: url
      };
    }),
    maxAvatars: max
  });
};
export default UsersAvatarList;